// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_xHZ","cls2":"TranslationModal-cls2_t-I TranslationModal-cls1_xHZ"};